
import { 
  DATALAYER_VALUES, 
  DATALAYER_CONFIG, 
  DATALAYER_EVENTS 
} from '../constants';
import { 
  DataLayerEvent, 
  VirtualPageEvent, 
  PageViewTrackingEvent 
} from '../types';

const pushToDataLayer = (event: Partial<DataLayerEvent>) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(event);
  }
};

const trackPageView = ({ pagePath, pageName, clasePagina }: PageViewTrackingEvent) => {
  const event: VirtualPageEvent = {
    event: DATALAYER_EVENTS.VIRTUAL_PAGE,
    pagePath,
    pageName,
    partner: DATALAYER_CONFIG.PARTNER,
    partnerType: DATALAYER_CONFIG.PARTNER_TYPE,
    clasePagina,
  };
  pushToDataLayer(event);
};

export const trackBCPAlternativePageView = () => {
  trackPageView({
    pagePath: DATALAYER_VALUES.PAGES.BCP_ALTERNATIVE,
    pageName: DATALAYER_VALUES.PAGE_NAMES.INICIO,
    clasePagina: DATALAYER_VALUES.CLASS_PAGES.INICIO
  });
};

export const trackBCPAlternativeThankYouPageView = () => {
  trackPageView({
    pagePath: DATALAYER_VALUES.PAGES.BCP_ALTERNATIVE_THANKS,
    pageName: DATALAYER_VALUES.PAGE_NAMES.GRACIAS,
    clasePagina: DATALAYER_VALUES.CLASS_PAGES.GRACIAS
  });
};